
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/archives",
      function () {
        return require("private-next-pages/collections-and-research/archives/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/archives"])
      });
    }
  